export default "__VITE_ASSET__DvAmYmoc__"